import React, { useContext, useEffect, useState } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import { Context } from '../Context/DataContext';
import { apiRequest } from '../utils/apiCalls';
import { useHistory, useLocation } from 'react-router';


const EditProduct = () => {

    const location = useLocation();
    const { p_age, p_boxes, p_id, p_MSRP, p_color, p_manufacturer, p_exp_id,
        p_type, p_name, p_price, p_status, pb_id, st_id, } = location?.state


    const history = useHistory();
    const [loading, setLoading] = useState(false)
    const { state, setProductsGlobal } = useContext(Context)
    const [prodData, setProdData] = useState({
        p_id: p_id,
        st_id: state.storeData.st_id,
        p_name: p_name,
        p_price: p_price,
        p_age: p_age,
        p_status: p_status,
        p_exp_id: p_exp_id,
        // st_id: state?.storeData[0]?.st_id ? state.storeData[0].st_id : '',
        p_MSRP: p_MSRP,
        p_color: p_color,
        p_manufacturer: p_manufacturer,
        p_type: p_type
    })
    const [manufacturs, setManufacturs] = useState([])
    const [expiries, setExpiries] = useState(state?.expiries ? state.expiries : [])


    function AddProd() {

        setLoading(true)
        console.log('mydata is')
        console.log(prodData)
        apiRequest(prodData, 'editprod')
            .then(data => {

                setLoading(false)
                console.log(data)
                if (data.status == '1') {
                    // alert('Product Updated')
                    if (data.data) {
                        setProductsGlobal(data.data)
                    }
                    history.replace('viewProducts')
                }
                else {
                    alert(data.error)
                }
            })
            .catch(err => {
                console.log(err)
                alert("Network error")
                setLoading(false)
            })

    }


    function formatExpiry(expiry) {
        if (expiry == '1') return 'Daily'
        if (expiry == '7') return 'Weekly'
        if (expiry == '14') return 'Bi-Weekly'
        if (expiry == '30') return 'Monthly'
        else return expiry

    }


    function getManufacturs() {

        setLoading(true)
        const st_id = state.storeData.st_id
        apiRequest({ st_id: st_id }, 'viewManufactur')
            .then(data => {
                setLoading(false)
                if (data.status == 1) {
                    setManufacturs(data.data)
                    // setCustomersGlobal(data.data)
                }

            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }

    function getexpiries() {

        setLoading(true)
        const st_id = state.storeData.st_id
        apiRequest({ st_id: st_id }, 'viewExpiries')
            .then(data => {
                setLoading(false)
                if (data.status == 1) {
                    // alert('get')
                    setExpiries(data.data)
                    // setCustomersGlobal(data.data)
                }

            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }



    useEffect(() => {
        getManufacturs();
        if (!location.state?.p_age) {
            history.push('./viewProducts')
        }
        getexpiries();

    }, [])

    return (
        <div>
            <div id="wrapper">
                <Sidebar />

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    {/* Main Content */}
                    <div id="content">
                        <Topbar />

                        {/* Begin Page Content */}
                        <div className="container-fluid">
                            <Modal

                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Heading */}
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">Edit Product</h1>
                            </div>

                            <div className="row">
                                <form id="frm_product">
                                    <input type="hidden" name="ser_id" defaultValue={1} />
                                    <input
                                        type="hidden"
                                        name="g_name"
                                        className="form-control form-control-user"
                                        placeholder="From - Garage name"
                                        defaultValue
                                    />
                                    <input
                                        type="hidden"
                                        name="g_phone"
                                        className="form-control form-control-user"
                                        placeholder="From - Garage phone"
                                        defaultValue
                                    />
                                    <input
                                        type="hidden"
                                        name="g_email"
                                        className="form-control form-control-user"
                                        placeholder="From - Garage email"
                                        defaultValue
                                    />
                                    <div className="form-group row">

                                        <div className="col-sm-6">
                                            <div className="editDetails" >Name</div>
                                            <input
                                                type="text"
                                                name="p_name"
                                                id="p_name"
                                                title="Name"
                                                className="form-control form-control-user"
                                                placeholder="Name"
                                                value={prodData.p_name}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_name: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>
                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Manufacturer</div>
                                            <select
                                                name="Manufacturer"
                                                id="p_Manufacturer"
                                                title="Manufacturer"
                                                className="form-control form-control-user"
                                                placeholder="Manufacturer"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_manufacturer: v.target.value
                                                    })
                                                }}
                                            >
                                                <option value selected disabled>
                                                    Manufacturer
                                                </option>
                                                {
                                                    manufacturs?.map((v) => {
                                                        return (
                                                            <option selected={v.pb_name == prodData.p_manufacturer ? true : false} value={v.pb_name}>{v.pb_name}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <br />
                                        </div>

                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Price</div>
                                            <input
                                                type="number"
                                                name="p_price"
                                                id="p_price"
                                                title="Price"
                                                className="form-control form-control-user"
                                                placeholder="Price"
                                                value={prodData.p_price}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_price: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>
                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >MSRP</div>
                                            <input
                                                type="number"
                                                name="MSRP"
                                                id="p_boxes"
                                                title=" MSRP (Manufacturer's Suggested Retail Price)"
                                                className="form-control form-control-user"
                                                placeholder="MSRP (Manufacturer's Suggested Retail Price)"
                                                value={prodData.p_MSRP}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_MSRP: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>
                                        {/* <div id="div_own_email" className="col-sm-6 mb-3 mb-sm-0">
                                            <input
                                                type="number"
                                                id="p_age"
                                                name="p_age"
                                                title="Age"
                                                className="form-control form-control-user"
                                                placeholder="Age"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_age: v.target.value
                                                    })
                                                }}
                                            />{" "}
                                            <br />
                                        </div> */}
                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Color</div>
                                            <input
                                                type="text"
                                                name="Color"
                                                id="p_color"
                                                title="Color"
                                                className="form-control form-control-user"
                                                placeholder="Color"
                                                value={prodData.p_color}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_color: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>

                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Type</div>
                                            <select
                                                name="Type"
                                                id="p_Type"
                                                title="Type"
                                                className="form-control form-control-user"
                                                placeholder="Type"
                                                value={prodData.p_type}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_type: v.target.value
                                                    })
                                                }}
                                            >
                                                <option value selected disabled>
                                                    Type
                                                </option>
                                                <option value={'Single vision'}>Single vision</option>
                                                <option value={'multi vision'}>Multi vision</option>
                                            </select>
                                            <br />
                                        </div>

                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Expiry</div>
                                            <select
                                                required
                                                name="p_status"
                                                id="p_status"
                                                title="Status"
                                                className="form-control form-control-user"
                                                placeholder="Expiry"

                                                onChange={(v) => {
                                                    let obj = v.target.value;
                                                    obj = JSON.parse(obj);
                                                    let arr = prodData;
                                                    arr.p_exp_id = obj.exp_id;
                                                    arr.p_age = obj.exp_no_days;
                                                    setProdData(arr);
                                                    // setProdData({
                                                    //     ...prodData,
                                                    //     p_age: v.target.value
                                                    // })
                                                }}
                                            >
                                                {
                                                    expiries.map((v, i) => {
                                                        const spacing = Array.from(Array(2 * 1.5), () => '\u00A0');

                                                        return (
                                                            // <div style={{marginLeft:20}}>
                                                            <option
                                                                key={i}
                                                                selected={prodData.p_age == v.exp_no_days && location.state.p_exp_id == v.exp_id ? true : false}
                                                                value={JSON.stringify(v)}
                                                                disabled={v.parent == 0 ? true : false}
                                                            // className='ml-4'
                                                            > {v.parent != '0' && spacing}      {v.exp_title}
                                                            </option>
                                                        )
                                                    })
                                                }
                                                {/* <option value={1}>Daily</option>
                                                <option value={7}>Weekly</option>
                                                <option value={14}>Bi-Weekly</option>
                                                <option value={30}>Monthly</option> */}
                                            </select>
                                            <br />
                                        </div>
                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Status</div>
                                            <select
                                                name="p_status"
                                                id="p_status"
                                                title="Status"
                                                className="form-control form-control-user"
                                                placeholder="Status"
                                                value={prodData.p_status}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_status: v.target.value
                                                    })
                                                }}
                                            >
                                                <option value selected disabled>
                                                    Status
                                                </option>
                                                <option value={1}>Active</option>
                                                <option value={0}>Inactive</option>
                                            </select>
                                            <br />
                                        </div>
                                        <Button
                                            onClick={() => AddProd()}
                                            // href="javascript://"
                                            // id="add_product"
                                            className="btn btn-primary btn-user btn-block"
                                            style={{ backgroundColor: AppColors.primary, borderWidth: 0, width: "95%", marginLeft: "2%", color: 'white', fontFamily: 'RBo' }}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </form>
                            </div>




                            {/* <div className="row">
                                <form id="frm_product">
                                    <input type="hidden" name="ser_id" defaultValue={1} />
                                    <input
                                        type="hidden"
                                        name="g_name"
                                        className="form-control form-control-user"
                                        placeholder="From - Garage name"
                                        defaultValue
                                    />
                                    <input
                                        type="hidden"
                                        name="g_phone"
                                        className="form-control form-control-user"
                                        placeholder="From - Garage phone"
                                        defaultValue
                                    />
                                    <input
                                        type="hidden"
                                        name="g_email"
                                        className="form-control form-control-user"
                                        placeholder="From - Garage email"
                                        defaultValue
                                    />
                                    <div className="form-group row">
                                       
                                        <div className="col-sm-6">
                                            <input
                                                type="text"
                                                name="p_name"
                                                id="p_name"
                                                title="Name"
                                                className="form-control form-control-user"
                                                placeholder="Name"
                                                value={prodData.p_name}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_name: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>
                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <input
                                                type="number"
                                                name="p_price"
                                                id="p_price"
                                                title="Price"
                                                className="form-control form-control-user"
                                                placeholder="Price"
                                                value={prodData.p_price}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_price: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>
                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <input
                                                type="number"
                                                name="p_boxes"
                                                id="p_boxes"
                                                title="Packet"
                                                className="form-control form-control-user"
                                                placeholder="Packets"
                                                value={prodData.p_boxes}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_boxes: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>
                                        
                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <select
                                                name="p_status"
                                                id="p_status"
                                                title="Status"
                                                className="form-control form-control-user"
                                                placeholder="Expiry"
                                                value={prodData.p_age}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_age: v.target.value
                                                    })
                                                }}
                                            >
                                                <option value selected disabled>
                                                    Expiry
                                                </option>
                                                <option value={1}>Daily</option>
                                                <option value={7}>Weekly</option>
                                                <option value={14}>Bi-Weekly</option>
                                                <option value={30}>Monthly</option>
                                            </select>
                                            <br />
                                        </div>
                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <select
                                                name="p_status"
                                                id="p_status"
                                                title="Status"
                                                className="form-control form-control-user"
                                                placeholder="Status"
                                                value={prodData.p_status}
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_status: v.target.value
                                                    })
                                                }}
                                            >
                                                <option value selected disabled>
                                                    Status
                                                </option>
                                                <option value={1}>Active</option>
                                                <option value={0}>Inactive</option>
                                            </select>
                                            <br />
                                        </div>
                                        <Button
                                            onClick={() => AddProd()}
                                            // href="javascript://"
                                            // id="add_product"
                                            className="btn btn-primary btn-user btn-block"
                                            style={{ backgroundColor: AppColors.primary, borderWidth: 0, width: "95%", marginLeft: "2%", color: 'white', fontFamily: 'RBo' }}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </form>
                            </div>
                            
                             */}

                            {/* /.container-fluid */}
                        </div>
                        {/* End of Main Content */}
                    </div>
                    {/* End of Content Wrapper */}
                </div >
                {/* End of Page Wrapper */}
                {/* Scroll to Top Button*/}
                <a className="scroll-to-top rounded" href="#page-top">
                    <i className="fas fa-angle-up" />
                </a>
                {/* Logout Modal*/}
                <div
                    className="modal fade"
                    id="logoutModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Ready to Leave?
                                </h5>
                                <button
                                    className="close"
                                    type="button"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                Select "Logout" below if you are ready to end your current session.
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    type="button"
                                    data-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <a className="btn btn-primary" href="logout.php">
                                    Logout
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </div >
    )
}

export default EditProduct
